export default "__VITE_ASSET__CglZXvLd__"